import {
  LAUNCH_TOKEN_KEY,
  LAUNCH_GOOGLE_ID_KEY,
  LAUNCH_PROFILE_KEY,
  LAUNCH_EXPIRY_KEY,
} from './launch.constants';

/**
 * Retorna true solo si existen token + googleId Y la sesión no ha expirado.
 * Los Google access tokens duran ~1 hora, por lo que datos viejos de
 * sesiones anteriores son tratados como inválidos.
 */
export const hasLaunchAuth = (): boolean => {
  const token    = localStorage.getItem(LAUNCH_TOKEN_KEY);
  const googleId = localStorage.getItem(LAUNCH_GOOGLE_ID_KEY);
  const expiry   = localStorage.getItem(LAUNCH_EXPIRY_KEY);

  if (!token || !googleId) return false;
  if (!expiry) return false; // datos sin expiración (formato antiguo) → forzar re-login
  return Date.now() < Number(expiry);
};

export const clearLaunchAuth = (): void => {
  localStorage.removeItem(LAUNCH_TOKEN_KEY);
  localStorage.removeItem(LAUNCH_GOOGLE_ID_KEY);
  localStorage.removeItem(LAUNCH_PROFILE_KEY);
  localStorage.removeItem(LAUNCH_EXPIRY_KEY);
};
